import React from 'react';
import PageAuthorize from '../../../../security/PageAuthorize';
import ListContainer from '../../../../presentation/ListContainer';

import clientLayout from '../../clients/components/layout.json';
import contactsLayout from '../../contacts/components/layout.json';
import callCentersLayout from '../../centers/components/layout.json';
import gatewaysLayout from './layout.json';
import numbersLayout from '../../numbers/components/layout.json';

class EntityGatewaysList extends React.Component {
  constructor( props ){
    super( props );
    this.layouts = [clientLayout, contactsLayout, callCentersLayout, gatewaysLayout, numbersLayout];
  }
  render(){
    return (
      <PageAuthorize groups={['Administrators','Operations','Entities']}>
        <ListContainer
          id="EntityGatewaysList"
          layout={gatewaysLayout}
          layouts={this.layouts}
          selectedtab={4}
        />
      </PageAuthorize>
    );
  }
}

export default EntityGatewaysList;



// WEBPACK FOOTER //
// ./src/content/entities/gateways/components/EntityGatewaysList.js